import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { AppContext } from "./ApplicationContextProvider";
import Loading from "../common/Loading";
import WrapperCard from "../common/WrapperCard";
import GenericError from "../pages/GenericError";
import type { AppContextType } from "./types";

export const TokenValidation: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const context = React.useContext(AppContext) as AppContextType;
  const { isTokenLoaded, loadToken, details, loader } = context;
  const token = params["token"];

  useEffect(() => {
    if (!token) return;

    if (isTokenLoaded && details?.businessLineDetails?.businessLine) {
      navigate(
        `/${details.businessLineDetails.businessLine}/token/${token}`
      );
    } else {
      loadToken(token);
    }
  }, [token, isTokenLoaded, details, navigate, loadToken]);

  return (
    <div className="app-display">
      {loader.loading ? (
        <WrapperCard>
          <Loading />
        </WrapperCard>
      ) : loader.error ? (
        <GenericError />
      ) : (
        <></>
      )}
    </div>
  );
};
